/*
  Modal Form Controller

  Handles submission of modal forms that may need to interact with other JS on the page through its emitted event

  EMITTED EVENTS
    update-success (document) Emitted when a modal form is successfully submitted
      detail: {
        el:  the root element of this controller instance,
        [Any number of key value pairs, where the key is an input name and the value is the value; these will be identified by making
        them detailTargets]
      }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['form', 'detail'];

  connect() {
    this.addHandlers();
  }

  addHandlers() {
    const form = App.Helpers.findElement(this.element, 'form');
    if (form) {
      App.Helpers.addModalHandlers(form);
      App.Helpers.addAjaxHandlers(form, this.handleSuccessfulFormSubmission.bind(this), this.handleFailedFormSubmission.bind(this));
    }
  }

  closeModal() {
    App.ActivityModalComponent.closeActivityModal(this.element.closest('.activity-modal--component'));
    App.Modal.closeAll();
  }

  //
  // INTERNAL USE
  //

  handleSuccessfulFormSubmission() {
    const e = createCustomEvent('update-success', this.element, this.buildDetailsObject());
    document.dispatchEvent(e);
    this.closeModal();
  }

  handleFailedFormSubmission(event, { responseText }) {
    this.html = responseText;
  }

  buildDetailsObject() {
    return this.detailTargets.reduce((obj, detail) => ({ ...obj, [detail.name]: detail.value }), {});
  }

  //
  // GETTERS AND SETTERS
  //

  set html(str) {
    this.replaceRoot ? App.Helpers.replaceElement(this.element, str) : (this.element.innerHTML = str);
    this.addHandlers();
  }

  get replaceRoot() {
    return ![1, '1', true, 'true'].includes(this.data.get('element-content-from-server'));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/modals/modal-form-controller.js